module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lori Copeland\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Lori Copeland is a bestselling author whose books includde Now and Always, Simple Gifts, Unwrapping Christmas, and Monday Morning Faith, which was a finalist for the 2007 Christy Awards. Lori was inducted into the Springfield Writers Hall of Fame in 2000 and lives in the beautiful Ozarks with her husband and family.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9br2Tf/images/cover.jpg?1708648519307",
      "alt": "This image is the cover for the book Stranded in Paradise"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stranded in Paradise\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A funny-but-touching tale about everything that can go wrong...and what makes it all right!")]), _c('p', [_vm._v("Tess Nelson is poised to take a well-deserved step up the corporate ladder when it's yanked out from under her. With no job and nothing to fill her days--just a nonrefundable ticket for a trip to Hawaii--Tess decides a tropical vacation is just what she needs. But Tess's journey to paradise is a disaster from the beginning. A sprained ankle at the airport is just the beginning. Then there's the lost contact lens and the lost luggage, the lightning storm at a luau, and the hotel fire. Not to mention the approaching hurricane. And the attractive, annoying young man who keeps crossing her path--and really shaking her up. All Tess wants to do is get her life back under control. But God, it seems, has something else in mind--like opening her heart to everything her life could be.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0